import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b32474ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center gap-5 flex-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "w-100 h-100 d-flex justify-content-center align-items-center"
}
const _hoisted_3 = { class: "table table-tenant" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

import { ref, onMounted } from "vue";
import TradeServices from "../services/TradeServices";
import moment from "moment";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import ExcludedAccountsModal from "../modals/ExcludedAccountsModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfitLoss',
  setup(__props) {

const excludedAccountsRef = ref<InstanceType<typeof ExcludedAccountsModal>>();

const date = ref<any>(moment().format("YYYY-MM-DD"));
const dateType = ref("date");

const isLoading = ref(false);
const data = ref<any[]>([]);
const criteria = ref<any>({
  date: date.value,
  percentage: 10,
  accountNumber: null,
  currencyId: 840,
});

const valueFormat = ref("YYYY-MM-DD");

const setToday = () => {
  date.value = moment().format("YYYY-MM-DD");
  criteria.value.accountNumber = null;
  criteria.value.percentage = 10;
  criteria.value.currencyId = 840;
};

const fetchData = async (page: number) => {
  isLoading.value = true;
  try {
    criteria.value.date = date.value;

    // Prepare request criteria
    const requestCriteria = { ...criteria.value };

    // If accountNumber is provided, exclude percentage and currencyId from request
    if (requestCriteria.accountNumber) {
      delete requestCriteria.percentage;
      delete requestCriteria.currencyId;
    } else {
      // If no accountNumber and percentage is null, undefined, or empty string, use 10
      if (
        requestCriteria.percentage === null ||
        requestCriteria.percentage === undefined ||
        requestCriteria.percentage === "" ||
        isNaN(requestCriteria.percentage)
      ) {
        requestCriteria.percentage = 10;
      }
    }

    const response = await TradeServices.queryProfitAndLossV2(requestCriteria);
    data.value = response;
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_input, {
          modelValue: criteria.value.accountNumber,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.accountNumber) = $event)),
          placeholder: _ctx.$t('fields.accountNo'),
          class: "w-150px no-number-arrows",
          disabled: isLoading.value,
          clearable: ""
        }, null, 8, ["modelValue", "placeholder", "disabled"]),
        _createVNode(_component_el_input, {
          modelValue: criteria.value.percentage,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.percentage) = $event)),
          modelModifiers: { number: true },
          type: "number",
          placeholder: 10,
          class: "w-250px",
          disabled: isLoading.value
        }, {
          prepend: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("fields.profitRate")), 1)
          ]),
          append: _withCtx(() => [
            _createTextVNode("%")
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"]),
        _createVNode(_component_el_select, {
          modelValue: criteria.value.currencyId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.currencyId) = $event)),
          placeholder: _ctx.$t('fields.currency'),
          class: "w-150px",
          disabled: isLoading.value,
          clearable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: _ctx.$t('type.currency.840'),
              value: 840
            }, null, 8, ["label"]),
            _createVNode(_component_el_option, {
              label: _ctx.$t('type.currency.841'),
              value: 841
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "disabled"]),
        _createVNode(_component_el_date_picker, {
          modelValue: date.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((date).value = $event)),
          type: dateType.value,
          "value-format": valueFormat.value,
          placeholder: "Time",
          class: "w-150px",
          disabled: isLoading.value,
          clearable: false
        }, null, 8, ["modelValue", "type", "value-format", "disabled"]),
        _createVNode(_component_el_button, {
          onClick: setToday,
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (fetchData(1))),
          plain: "",
          loading: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          disabled: isLoading.value,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (excludedAccountsRef.value?.show()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Excluded Accounts ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(ExcludedAccountsModal, {
        ref_key: "excludedAccountsRef",
        ref: excludedAccountsRef,
        onSaved: _cache[6] || (_cache[6] = ($event: any) => (fetchData(1)))
      }, null, 512),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(ScaleLoader, { color: '#ffc730' })
          ]))
        : (_openBlock(), _createBlock(_component_el_tabs, {
            key: 1,
            type: "border-card",
            class: "demo-tabs"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, key) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  key: key,
                  label: key
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_3, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.netInOut")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.profit")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.percentage")), 1)
                        ])
                      ]),
                      (!isLoading.value && data.value[key].length == 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                            _createVNode(_component_NoDataBox)
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value[key], (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", null, _toDisplayString(item.accountNumber), 1),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_BalanceShow, {
                                    balance: item.netInOut
                                  }, null, 8, ["balance"])
                                ]),
                                _createElementVNode("td", null, [
                                  _createVNode(_component_BalanceShow, {
                                    balance: item.profit
                                  }, null, 8, ["balance"])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(item.profitPercent) + " %", 1)
                              ]))
                            }), 128))
                          ]))
                    ])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})